<div class="flex flex-row flex-wrap overflow-y-hidden">
  <div class="text-left w-1/2">
    <a class="footer-headline text-ace-gray-400" data-test="footerCategories" href="{{ headlineLink }}">{{
      headlineText
    }}</a>
  </div>
  @if (!headlineLink) {
    <div class="text-right w-1/2">
      <span class="footer-arrow text-ace-gray-400 pr-2" data-test="footerArrows">
        @if (sectionOpen) {
          <span (click)="sectionOpen = !sectionOpen">
            <fa-icon [icon]="faCaretDown" [styles]="sectionIconStyle"></fa-icon>
          </span>
        } @else {
          <span (click)="sectionOpen = !sectionOpen">
            <fa-icon [icon]="faCaretRight" [styles]="sectionIconStyle"></fa-icon>
          </span>
        }
      </span>
    </div>
  }
  <div
    class="footer-link-section text-left text-xs underline text-dec-gray-400"
    [ngClass]="{ collapsed: !sectionOpen }"
    >
    <ul class="pt-4" data-test="footerLists">
      @for (subLink of subLinks; track subLink; let i = $index) {
        <li>
          @if (subLink.text === 'Privacy Policy') {
            <a target="_blank" rel="noopener noreferrer" href="{{ subLink.subLink }}">{{ subLink.text }}</a>
          } @else {
            <a href="{{ subLink.subLink }}" [attr.rel]="shouldHaveNofollow(subLink.nofollow)">{{ subLink.text }}</a>
          }
        </li>
      }
    </ul>
  </div>
</div>
<hr class="my-2" style="height: 1px" />
